// @flow

export {
  default as Apollo,
  buildCache,
  buildClient,
  getApolloClient,
  getObjectId,
  getObjectIdField,
  getCacheKey,
  replaceCache,
  writeToDummyCache,
  restoreGraphQLResults,
} from './Apollo';

export type { ApolloCache, ApolloQueryResult } from './Apollo';

export {
  getQueuedRequests as getApolloQueuedRequests,
  fulfill as fulfillApolloBatch,
} from './MicroserviceBatchLink';

export { default as fulfillDataApiBatch } from './DataApiFulfiller';

export { default as Root } from './Root';

export { default as DummyCache } from './DummyCache';

export { default as LithiumBridge } from './LithiumBridge';
